import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import Banking pages
import BanqueAlertsPage from './BanqueAlertsPage';
import BankAccountsPage from './BankAccountsPage';
import ReconciliationPage from './ReconciliationPage';
import AutoReconciliationPage from './AutoReconciliationPage';
import ManualReconciliationPage from './ManualReconciliationPage';
import DiscrepanciesPage from './DiscrepanciesPage';
import BankTransfersPage from './BankTransfersPage';
import PendingChecksPage from './PendingChecksPage';
import BankStatementsPage from './BankStatementsPage';
import BankFeesPage from './BankFeesPage';
import PaymentOrdersPage from './PaymentOrdersPage';
import BankingConfigPage from './BankingConfigPage';
import AccountingPage from './AccountingPage';
import BankingAnalysesRapportsPage from './BankingAnalysesRapportsPage';
import BankingDashboardPage from './BankingDashboardPage';

const BankingMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.banque.pages.bankingMainPage.${key}`, opts);

  return (
    <div aria-label={p('title')}>
    <span className="sr-only">{p('subtitle')}</span>
    <Routes>
      <Route path="/dashboard" element={<BankingDashboardPage />} />
      {/* Alertes */}
      <Route path="/alertes" element={<BanqueAlertsPage />} />
      {/* Comptes Bancaires */}
      <Route path="/accounts" element={<BankAccountsPage />} />
      {/* Rapprochement Bancaire */}
      <Route path="/reconciliation/general" element={<ReconciliationPage />} />
      <Route path="/reconciliation/auto" element={<AutoReconciliationPage />} />
      <Route path="/reconciliation/manual" element={<ManualReconciliationPage />} />
      <Route path="/reconciliation/discrepancies" element={<DiscrepanciesPage />} />
      {/* Virements */}
      <Route path="/transfers" element={<BankTransfersPage />} />
      {/* Chèques */}
      <Route path="/checks" element={<PendingChecksPage />} />
      {/* Relevés Bancaires */}
      <Route path="/statements" element={<BankStatementsPage />} />
      {/* Frais Bancaires */}
      <Route path="/fees" element={<BankFeesPage />} />
      {/* Ordres de Paiement */}
      <Route path="/payment-orders" element={<PaymentOrdersPage />} />
      {/* Configuration */}
      <Route path="/config" element={<BankingConfigPage />} />
      {/* Écritures Comptables */}
      <Route path="/accounting" element={<AccountingPage />} />
      {/* Analyses & Rapports */}
      <Route path="/analyses-rapports" element={<BankingAnalysesRapportsPage />} />
      <Route path="/reconciliation" element={<Navigate to="/banking/reconciliation/general" replace />} />
      <Route path="/" element={<Navigate to="/banking/dashboard" replace />} />
    </Routes>
    </div>
  );
};

export default BankingMainPage;

